import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SharedLavorazioniModule } from '../../../../lavorazioni/modules/shared-lavorazioni/shared-lavorazioni.module';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { CompanyLocation } from '../../../../../../../interfaces/company-location';
import { debounceTime, distinctUntilChanged, filter, map, Observable, of, startWith, switchMap, take, tap } from 'rxjs';
import { CustomerAutocomplete } from '../../../../customer/interfaces/customer-autocomplete';
import { SearchAutocompleteService } from '../../../../../../../services/search-autocomplete.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Address } from '../../../../customer/interfaces/address';
import { User } from '../../../../../../../interfaces/user';
import { TrainingCourse } from '../../../../training/interfaces/training-course';
import { CalendarEventFormService } from './calendar-event-form.service';
import { ApiResponse } from '../../../../../../../interfaces/api-response';
import { PopupService } from '../../../../../../../services/popup.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { Student } from '../../../../customer/interfaces/student';

@Component({
    selector: 'app-dialog-manage-event',
    imports: [
        CommonModule,
        MatDialogModule,
        SharedLavorazioniModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatSelectModule,
        MatAutocompleteModule,
        DragDropModule
    ],
    templateUrl: './dialog-manage-event.component.html',
    styleUrl: './dialog-manage-event.component.scss'
})
export class DialogManageEventComponent {

  submitted = false;
  isSmall = false;
  eventForm: FormGroup;

  // Liste per i select
  listCalendarTypes: any[] = [];
  filteredCustomers$!: Observable<CustomerAutocomplete[]>;
  courseList: TrainingCourse[] = [];
  roomList: { id: number, name: string }[] = [];
  headquarterList: CompanyLocation[] = [];
  customerheadquarterList: Address[] = [];
  contactList: { id: number; name: string }[] = [];
  studentsList: Student[] = [];
  usersList$!: Observable<User[]>;
  changeEventFirstTime = 1;

  private calendar_type: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogManageEventComponent>,
    private searchAutocompleteService: SearchAutocompleteService,
    private formService: CalendarEventFormService,
    private popupService: PopupService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Crea il form usando il servizio
    this.eventForm = this.formService.createEventForm();

    // Imposta l'idevent dai dati passati
    this.eventForm.get('idevent')?.setValue(data.idevent);

    // Imposta i tipi di calendario se forniti
    if (data.calendar_type && data.calendar_type.length > 0) {
      this.calendar_type = data.calendar_type;
    }
  }

  ngOnInit(): void {
    const idevent = this.eventForm.get('idevent')?.value;

    // Setup comune - sempre necessario
    this.updateWindowDimensions();

    this.setupSearches();

    if (idevent && idevent > 0) {
      this.loadAllData('edit');
      // Carica i dati dell'evento esistente
      this.loadExistingEvent(idevent);
    } else {
      this.loadAllData('new');
      // Inizializza il form per un nuovo evento
      this.formService.setupFormLogic(this.eventForm);
      this.eventForm.patchValue(this.formService.defaultValues);
    }
  }

  private loadExistingEvent(idevent: number): void {

    this.formService.loadEventData(idevent).subscribe(
      (eventData) => {
        // console.log('eventData', eventData);
        if (eventData.data.infoEventCalendar) {
          // Setup della logica SENZA il listener customer per evitare trigger durante il patch
          this.formService.setupFormLogic(this.eventForm, true);
          // Applica i dati e la logica del form
          const customerHeadquarterId = this.formService.applyEventData(this.eventForm, eventData.data.infoEventCalendar);
          // console.log('customerHeadquarterId', customerHeadquarterId);
          // Se c'è un cliente, carica le sue sedi e contatti
          // if (eventData.data.infoEventCalendar.customer &&
          //   eventData.data.infoEventCalendar.customer.idregistry) {
          //   this.loadCustomerLocationContactsStudents(eventData.data.infoEventCalendar.customer.idregistry).subscribe((data) => {
          //     this.customerheadquarterList = data.data.locations || [];
          //     this.contactList = data.data.contacts || [];
          //     this.studentsList = data.data.students || [];

          //     // Ora che le sedi sono caricate, imposta il customer_headquarter se presente
          //     if (customerHeadquarterId && this.customerheadquarterList.length > 0) {
          //       // console.log('this.customerheadquarterList', this.customerheadquarterList);
          //       // console.log('customerHeadquarterId', customerHeadquarterId);
          //       // Verifica che la sede esista nella lista caricata
          //       const headquarterExists = this.customerheadquarterList.some(
          //         location => location.idlocation === customerHeadquarterId
          //       );
          //       if (headquarterExists) {
          //         this.eventForm.get('customer_headquarter')?.setValue(customerHeadquarterId);
          //       }
          //     }

          //     // DOPO aver caricato tutto, registra il listener customer per i cambiamenti futuri
          //     // this.setupCustomerValueChangesListener();
          //   });
          // } else {
          //   // Se non c'è cliente, registra comunque il listener
          //   this.setupCustomerValueChangesListener();
          // }
        }
      });
  }

  private setupCustomerValueChangesListener(): void {
    // Registra il listener per customer solo dopo che i dati iniziali sono stati caricati
    this.eventForm.get('customer')?.valueChanges.subscribe(value => {
      this.formService.applyCustomerLogic(this.eventForm, value);
    });
  }

  /**
   * SEMPRE ALL'AVVIO
   * Caricamento dati
   */
  private loadAllData(type: string): void {
    // Carica i tipi di calendario
    this.formService.getCalendarTypes(this.calendar_type).subscribe(
      result => this.listCalendarTypes = result
    );

    // Carica le sedi
    this.formService.getHeadquarters().subscribe(
      result => this.headquarterList = result
    );

    // Carica i corsi
    this.formService.getCourses().subscribe(
      (corsi: TrainingCourse[]) => this.courseList = corsi
    );

    // Carica gli utenti
    this.usersList$ = this.formService.getUsersList();

    if (type === 'new') {
      // Setup selezione utente corrente
      this.formService.setupUserSelection(this.eventForm, this.usersList$);
    }

  }

  /**
   * SEMPRE ALL'AVVIO
   * Setup delle ricerche e delle selezioni
   */
  private setupSearches(): void {
    this.searchCustomer();
    this.setupCustomerSelection();
  }

  private searchCustomer(): void {
    const customer_field = this.eventForm.get('customer');
    if (customer_field) {
      this.filteredCustomers$ = customer_field.valueChanges.pipe(
        startWith(''),
        tap(value => {
          if (!value || typeof value === 'string') {

            // console.log('AAAAA - clearCustomerRelatedFields');
            this.clearCustomerRelatedFields();

          }
        }),
        map(value => typeof value === 'string' ? value : value?.denomination || ''),
        filter(value => value.length > 1),
        debounceTime(700),
        switchMap((value: string) =>
          value ? this.searchAutocompleteService.getCustomer(0, value) : []
        )
      );
    } else {
      this.filteredCustomers$ = of([]);
    }
  }

  private setupCustomerSelection(): void {
    this.eventForm.get('customer')?.valueChanges.pipe(
      filter((value): value is CustomerAutocomplete => {
        return value !== null &&
          typeof value === 'object' &&
          'idregistry' in value &&
          !!value.idregistry;
      }),
      // distinctUntilChanged((prev, curr) => prev.idregistry === curr.idregistry),
      switchMap(customer => this.loadCustomerLocationContactsStudents(customer.idregistry))
    ).subscribe({
      next: (val) => {
        // console.log('CCCC - setupCustomerSelection');
        // console.log('DDDD - setupCustomerSelection', this.eventForm.get('customer_headquarter')?.value);
        this.customerheadquarterList = val.data.locations || [];
        this.contactList = val.data.contacts || [];
        this.studentsList = val.data.students || [];

        this.eventForm.get('customer_headquarter')?.enable();
        this.eventForm.get('idcontact')?.enable();
        this.eventForm.get('customerstudents')?.enable();

        if (this.changeEventFirstTime === 1 && this.eventForm.get('idevent')?.value > 0) {
          const temp_headquarter = this.eventForm.get('customer_headquarter')?.value;
          const temp_contact = this.eventForm.get('idcontact')?.value;
          const temp_students = this.eventForm.get('customerstudents')?.value;
          this.eventForm.get('customer_headquarter')?.setValue(temp_headquarter);
          this.eventForm.get('idcontact')?.setValue(temp_contact);
          this.eventForm.get('customerstudents')?.setValue(temp_students);
          this.changeEventFirstTime = 0;
        } else {
          this.eventForm.get('customer_headquarter')?.setValue(null);
          this.eventForm.get('idcontact')?.setValue(null);
          this.eventForm.get('customerstudents')?.setValue(null);
        }




      },
      error: (error) => {
        console.error('Errore nel caricamento dati cliente:', error);
      }
    });
  }

  private loadCustomerLocationContactsStudents(customerId: number): Observable<any> {
    return this.formService.getCustomerLocationContacts(customerId);
  }

  private clearCustomerRelatedFields(): void {
    this.customerheadquarterList = [];
    this.contactList = [];
    this.studentsList = [];
    this.eventForm.get('customer_headquarter')?.disable();
    this.eventForm.get('customer_headquarter')?.setValue(null);
    this.eventForm.get('idcontact')?.disable();
    this.eventForm.get('idcontact')?.setValue(null);
    this.eventForm.get('customerstudents')?.disable();
    this.eventForm.get('customerstudents')?.setValue(null);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.updateWindowDimensions();
  }

  updateWindowDimensions(): void {
    this.isSmall = window.innerWidth < 740;
  }

  displayCustomerName(customer?: CustomerAutocomplete): string {
    return customer ? customer.denomination! : '';
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.submitted = true;

    if (this.eventForm.valid) {

      const obj = this.eventForm.getRawValue()

      this.formService.saveEventData(obj).subscribe(
        (val: ApiResponse<{ id: number }>) => {
          this.popupService.alertElement(val);
          this.dialogRef.close({
            action: 'refresh'
          });

        });
    }
  }
}
